"use client";

import React from "react";
import { PostAuthors } from "@/views/post/partials/PostAuthors/PostAuthors";
import { PostBody } from "@/views/post/partials/PostBody/PostBody";
import { TabbedPosts } from "@/views/post/partials/TabbedPosts/TabbedPosts";
import { RelatedEntities } from "@/views/post/partials/RelatedEntities/RelatedEntities";
import { RelatedMatches } from "@/views/post/partials/RelatedMatches/RelatedMatches";
import { usePostData } from "@/views/post/context/PostDataContext";
import { VideoHeader } from "../../partials/VideoHeader/VideoHeader";
import { useLabels } from "@/lib/labels/LabelsProvider";
import { useNavigation } from "@/lib/navigation/NavigationProvider";
import { AdSlot } from "@/features/ads/AdSlot";
import { DiscussionWidget } from "@/features/discussion/DiscussionWidget";
import { SectionStrip, type BrandedStyle } from "@/components/layout/SectionStrip";
import { VIDEO_HERO } from "@/features/theme/sectionKeys";

interface VideoLayoutDefaultProps {
    sectionStyles?: Record<string, BrandedStyle>;
    breadcrumbs?: React.ReactNode;
}

export function VideoLayoutDefault({ sectionStyles, breadcrumbs }: VideoLayoutDefaultProps = {}) {
    const { post } = usePostData();
    const labels = useLabels();
    const nav = useNavigation();

    return (
        <article className="min-h-screen">
            <SectionStrip brandedStyle={sectionStyles?.[VIDEO_HERO]}>
                <VideoHeader breadcrumbs={breadcrumbs} />
            </SectionStrip>
            <div className="container max-w-240 mx-auto px-4 py-8 md:py-12 space-y-8">
                <AdSlot id="content-top" />

                <RelatedMatches showHeader={false} matchesLabel={(labels as any).videoPage?.relatedMatches} />
                <PostBody content={post.content} />
                <PostAuthors
                    authors={post.populatedAuthors}
                    authorLabel={(labels as any).videoPage?.author}
                    authorsLabel={(labels as any).videoPage?.authors}
                />
                <RelatedEntities aboutLabel={(labels as any).videoPage?.about} />
                <DiscussionWidget entityId={`post-${post.id}`} discussionLabel="Comments" className="mt-8" />
                <TabbedPosts
                    variant="standard"
                    buildLink={nav.post}
                    relatedLabel={(labels as any).videoPage?.relatedVideos}
                    categoryLabel={(labels as any).videoPage?.latestFromCategory}
                    latestLabel={(labels as any).videoPage?.latestNews}
                />

                <AdSlot id="content-bottom" />
            </div>
        </article>
    );
}
